import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const ExpDataExcel = async ({ resultados = []}) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Historico');
  
  // Definir columnas
  worksheet.columns = [
    { header: 'Periodo Id', key: 'periodoid', width: 15 },
    { header: 'Nombre Area', key: 'nombrearea', width: 25 },
    { header: 'Nombre Servicio', key: 'NombreServ', width: 25 },
    { header: 'Id Item', key: 'ItemId', width: 10 },
    { header: 'Fecha Ingreso', key: 'fechaing', width: 22 },
    { header: 'Fecha Llamada', key: 'fechallam', width: 22 },
    { header: 'Fecha Atencion', key: 'fechaatn', width: 22 },
    { header: 'Estado', key: 'estado', width: 15 },
  ];

  // Agregar datos
  worksheet.addRows(resultados);

  // Estilo al encabezado
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { size: 8, name: 'Verdana', color: { argb: 'FF000000' } };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'DDEBF7' }, // Azul oscuro
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  // Formatear fechas si son válidas
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return; // Saltar encabezado
    ['E', 'F', 'G'].forEach((col) => {
      const cell = row.getCell(col);
      if (cell.value && typeof cell.value === 'string' && !isNaN(Date.parse(cell.value))) {
        cell.value = new Date(cell.value);
        cell.numFmt = 'dd/mm/yyyy HH:MM:SS';
      }
    });
  });

  // Generar y descargar
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer]); // sin 'type'
  saveAs(blob, 'Informe_Historico.xlsx');

  //setshowexport(false);
};

export default ExpDataExcel;
